import { capitalize, has } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Table } from 'react-bootstrap';
import { INITIATIVE_TYPES } from '../../../lib/schema.js';
import SubHeader from '../../SubHeader.jsx';
import InitiativesTableRow from './InitiativesTableRow.jsx';

const InitiativesTable = ({
  initiatives,
  initiativeType,
  manageProjectEntities,
  isArchived,
  deleteInitiative,
  project,
  canDuplicate,
  newCopyId,
}) => {
  const initiativeTypeCapitalized =
    initiativeType === INITIATIVE_TYPES[1]
      ? `${capitalize(initiativeType)}es`
      : `${capitalize(initiativeType)}s`;

  if (initiatives.length === 0) {
    return (
      <SubHeader bgWhite small flex>
        <p className="text-muted m-0">
          {`There are no ${initiativeTypeCapitalized} yet.`}
        </p>
      </SubHeader>
    );
  }

  const enabledColumns = {
    mandatory: has(initiatives[0], 'mandatory'),
    completion: has(initiatives[0], 'completionTracked'),
  };

  return (
    <Table hover style={{ tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th width="20%">Title</th>
          <th>Category</th>
          {enabledColumns.completion && <th>Completion</th>}
          {enabledColumns.mandatory && <th>Mandatory</th>}
          <th>Feedback Form</th>
          <th>Lead</th>
          <th>Impact</th>
          <th width="160px">Date</th>
          <th width="110px" className="text-right">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        {initiatives
          ? initiatives.map((initiative) => (
              <InitiativesTableRow
                key={initiative.id}
                initiative={initiative}
                showMandatory={enabledColumns.mandatory}
                showCompletion={enabledColumns.completion}
                manageProjectEntities={manageProjectEntities}
                isArchived={isArchived}
                deleteInitiative={deleteInitiative}
                project={project}
                canDuplicate={canDuplicate}
                isNewCopy={initiative.id === newCopyId}
              />
            ))
          : null}
      </tbody>
    </Table>
  );
};

InitiativesTable.propTypes = {
  initiatives: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ).isRequired,
  // The copy just duplicated in this list, highlighted as "New copy".
  newCopyId: PropTypes.number,
};

InitiativesTable.defaultProps = {
  newCopyId: null,
};

export default InitiativesTable;
